import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Card, Typography, Spin, Row, Col } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import QRCode from 'react-qr-code'
import { fetchPackageDataFxn, getSingleEsimFxn } from './actions'
import './esim.css'

const { Title, Text } = Typography

const EsimSuccess = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)
  const [packageDetails, setPackageDetails] = useState({})
  const [packageResponse, setPackageResponse] = useState({})
  const [esimPayment, setEsimPayment] = useState({})
  const [qrError, setQrError] = useState(false)
  const [qrLoading, setQrLoading] = useState(false)
  const [qrCodeDataURL, setQrCodeDataURL] = useState('')

  useEffect(() => {
    loadEsimData()
  }, [window])

  const generateQRCode = async (esim) => {
    try {
      setQrLoading(true)
      setQrError(false)

      const activationCode = (esim && esim.activationCode) || (esim && esim.activationCode) || ''
      if (!activationCode) {
        throw new Error('No activation code found')
      }
      /*const qrDataURL = await QRCode.toDataURL(activationCode, {
        width: 250,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        },
        errorCorrectionLevel: 'M'
      })

      setQrCodeDataURL(qrDataURL)*/
      setQrLoading(false)
    } catch (error) {
      console.error('Error generating QR code:', error)
      setQrError(true)
      setQrLoading(false)
    }
  }


  const loadEsimData = async () => {
    let esimId = window.location.pathname.split('/').pop()
    let { data } = await dispatch(getSingleEsimFxn({ esimId }))

    /*    const payload = {
          esim_id: data && data.response && data.response.esim && data.response.esim.esim_id,
          package_id: data && data.request && data.request.package_id
        }

        const response = await dispatch(fetchPackageDataFxn(payload))
        console.log(response,'response');*/

    setPackageResponse(data.response || {})
    setEsimPayment(data.esimPaymentId || {})
    setPackageDetails(data)
    if (data && data.response && data.response.esim) {
      // generateQRCode(data.response.esim)
    }
  }


  /*  const {
      packageResponse,
      packageData,
      quantity,
      total
    } = location.state || {}

    const packageResp = useSelector(
      (state) => state.esimReducer.packageResp || ''
    )

    useEffect(() => {
      if (packageResponse && packageData) {
        fetchPackageDetails()
            generateQRCode();
        }
    }, [packageResponse, packageData])

    console.log(packageResponse, 'reps--------')


    const generateQRCode = async () => {
        try {
            setQrLoading(true);
            setQrError(false);

            const activationCode =
                (packageResponse.data && packageResponse.data.esim && packageResponse.data.esim.activationCode) ||
                (packageResponse && packageResponse.esim && packageResponse.esim.activationCode) || '';

            if (!activationCode) {
                throw new Error('No activation code found');
            }

            const qrDataURL = await QRCode.toDataURL(activationCode, {
                width: 250,
                margin: 2,
                color: {
                    dark: '#000000',
                    light: '#FFFFFF'
                },
                errorCorrectionLevel: 'M'
            });

            setQrCodeDataURL(qrDataURL);
            setQrLoading(false);
        } catch (error) {
            console.error('Error generating QR code:', error);
            setQrError(true);
            setQrLoading(false);
        }
    };
    const fetchPackageDetails = async () => {
      try {
        setLoading(true)

        const payload = {
          // token: token,
          esim_id: packageResponse.data.esim.esim_id,
          package_id: packageData.package_id
        }

        const response = await dispatch(fetchPackageDataFxn(payload))

        console.log(response, 'response---------')
        if (response && response.success) {
          setPackageDetails(response.data.data)
        }
      } catch (error) {
        console.error('Error fetching package details:', error)
      } finally {
        setLoading(false)
      }
    }*/

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A'
    return new Date(timestamp).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const formatBytes = (bytes) => {
    if (!bytes) return '0 GB'
    const gb = bytes / (1024 * 1024 * 1024)
    return `${gb.toFixed(2)} GB`
  }

  const formatSeconds = (seconds) => {
    if (!seconds) return '0 days'
    const days = Math.floor(seconds / (24 * 60 * 60))
    return `${days} days`
  }

  const handleQRImageLoad = () => {
        setQrLoading(false);
        setQrError(false);
    };

    const handleQRImageError = () => {
        setQrLoading(false);
        setQrError(true);
    };

    // Get activation code for display
    const activationCode =
        (packageResponse.data && packageResponse.data.esim && packageResponse.data.esim.activationCode) ||
        (packageResponse && packageResponse.esim && packageResponse.esim.activationCode) || '';
    return (
        <div className='esim-success-container'>
      {packageDetails && packageDetails.response && packageDetails.response.transaction_id ?
        <div>
          {esimPayment && esimPayment.status ? <Card className='card esim-success-card'>
            {esimPayment.status == 'Completed' || esimPayment.status == 'succeeded' ?
              <div className={'card-body'}>
                <div className='esim-success-header'>
                  <CheckCircleOutlined className='esim-success-icon' />
                  <Title level={2} className='esim-success-title'>
                    Payment Successful!
                  </Title>
                  <Text className='esim-success-subtitle'>
                    Your eSIM has been generated successfully
                  </Text>
                </div>

                <Row span={24}>
                  <Col span={12}>
                    <div className='esim-success-details'>
                      <div className='esim-success-section'>
                        <Title level={4}>Order Details</Title>
                        <div className='esim-detail-row'>
                          <Text>Transaction ID:</Text>
                          <Text
                            strong>{packageResponse.transaction_id || packageResponse.data.transaction_id || ''}</Text>
                        </div>
                        <div className='esim-detail-row'>
                          <Text>Date:</Text>
                          <Text>{packageResponse.date || packageResponse.data.date || ''}</Text>
                        </div>
                        <div className='esim-detail-row'>
                          <Text>Amount:</Text>
                          <Text
                            strong>${packageDetails && packageDetails.request && packageDetails.request.amount && packageDetails.request.amount.toFixed(2) || 0}</Text>
                        </div>
                        <div className='esim-detail-row'>
                          <Text>Quantity:</Text>
                          <Text>{esimPayment && esimPayment.quantity && esimPayment.quantity || 1}</Text>
                        </div>
                      </div>


                      {/*    {packageDetails && (
                      <>
                        <div className='esim-success-section'>
                          <Title level={4}>Package Status & Usage</Title>
                          <div className='esim-detail-row'>
                            <Text>Status:</Text>
                            <label
                              className={
                                packageDetails.status == 'TERMINATED'
                                  ? 'label label-danger label-sm'
                                  : packageDetails.status == 'NOT_ACTIVE'
                                  ? 'label label-warning label-sm'
                                  : packageDetails.status == 'ACTIVE'
                                    ? 'label label-success label-sm'
                                    : 'label'
                              }>
                              {packageDetails.status}
                            </label>

                          </div>
                          <div className='esim-detail-row'>
                            <Text>Package ID:</Text>
                            <Text strong>{packageDetails.packageId}</Text>
                          </div>
                          <div className='esim-detail-row'>
                            <Text>SIM ICCID:</Text>
                            <Text>{packageDetails.simIccid}</Text>
                          </div>
                          <div className='esim-detail-row'>
                            <Text>Package Type ID:</Text>
                            <Text>{packageDetails.packageTypeId}</Text>
                          </div>
                        </div>

                        <div className='esim-success-section'>
                          <Title level={4}>Usage Information</Title>
                          <div className='esim-detail-row'>
                            <Text>Data Remaining:</Text>
                            <Text>
                              {formatBytes(packageDetails.dataUsageRemainingInBytes)}
                            </Text>
                          </div>
                          <div className='esim-detail-row'>
                            <Text>Voice Remaining:</Text>
                            <Text>{packageDetails.voiceUsageRemainingInSeconds} seconds</Text>
                          </div>
                          <div className='esim-detail-row'>
                            <Text>SMS Remaining:</Text>
                            <Text>{packageDetails.smsUsageRemainingInNums}</Text>
                          </div>
                          <div className='esim-detail-row'>
                            <Text>Time Allowance:</Text>
                            <Text>{formatSeconds(packageDetails.timeAllowanceInSeconds)}</Text>
                          </div>
                        </div>


                      </>
                    )}*/}
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className='esim-success-section'>
                      <Title level={4}>eSIM Information</Title>
                      <div className='esim-detail-row'>
                        <Text>ICCID:</Text>
                        <Text
                          strong>{packageResponse.data && packageResponse.data.esim && packageResponse.data.esim.iccid ||
                        packageResponse && packageResponse.esim && packageResponse.esim.iccid
                        || ''}</Text>
                      </div>
                      <div className='esim-detail-row'>
                        <Text>SMDP:</Text>
                        <Text>{packageResponse.data && packageResponse.data.esim && packageResponse.data.esim.smdp ||
                        packageResponse && packageResponse.esim && packageResponse.esim.smdp
                        || ''}</Text>
                      </div>
                      <div className='esim-detail-row'>
                        <Text>Activation Code:</Text>
                        <Text className='esim-activation-code'>
                          {packageResponse.data && packageResponse.data.esim && packageResponse.data.esim.activationCode ||

                                        packageResponse && packageResponse.esim && packageResponse.esim.activationCode || ''}
                                    </Text>
                                </div>
                            </div>

                            {loading ? (
                              null
                            ) : packageDetails && (
                                <>
                                    <div className='esim-success-section'>
                          <Title level={4}>Important Dates</Title>
                          <div className='esim-detail-row'>
                            <Text>Created Date:</Text>
                            <Text>{formatDate(packageDetails.dateCreated)}</Text>
                          </div>
                          <div className='esim-detail-row'>
                            <Text>Activated Date:</Text>
                            <Text>{formatDate(packageDetails.dateActivated)}</Text>
                          </div>
                          <div className='esim-detail-row'>
                            <Text>Expiry Date:</Text>
                            <Text strong style={{ color: 'red' }}>
                              {formatDate(packageDetails.dateExpiry)}
                            </Text>
                          </div>
                          <div className='esim-detail-row'>
                            <Text>Termination Date:</Text>
                            <Text>{formatDate(packageDetails.dateTerminated)}</Text>
                          </div>
                        </div>

                        <div className='esim-success-section'>
                          <Title level={4}>Activation Window</Title>
                          <div className='esim-detail-row'>
                            <Text>Window Start:</Text>
                            <Text>{formatDate(packageDetails.windowActivationStart)}</Text>
                          </div>
                          <div className='esim-detail-row'>
                                            <Text>Window End:</Text>
                                            <Text>{formatDate(packageDetails.windowActivationEnd)}</Text>
                                        </div>
                                    </div>
                                </>
                            )}

                        </Col>

                        <Col span={24}>
                            {activationCode && (
                                <div className="esim-success-section">
                                    <Title level={4} style={{ textAlign: 'center', marginBottom: '20px' }}>
                                        Scan to Install eSIM
                                    </Title>
                                  <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                                    {qrLoading && (
                                      <div style={{ padding: '40px' }}>
                                        <Spin size='large' />
                                        <div style={{ marginTop: '16px' }}>
                                          <Text>Generating QR Code...</Text>
                                        </div>
                                      </div>
                                    )}


                                    {packageResponse && packageResponse.esim && packageResponse.esim.activationCode &&
                                    <>
                                      <QRCode
                                        value={packageResponse.esim.activationCode} // string to encode
                                        size={200}                 // pixel size
                                        level='H'                   // error correction level (L, M, Q, H)
                                        includeMargin={true}        // add white margin around QR
                                        bgColor='#ffffff'           // background color
                                        fgColor='#000000'           // foreground (QR color)
                                      />
                                    </>
                                    }


                                  </div>

                                    {!qrError && !qrLoading && qrCodeDataURL && (
                                        <>
                                            <Text style={{ display: 'block', textAlign: 'center', marginBottom: '8px' }}>
                                                <strong>Scan this QR code with your device to install the eSIM</strong>
                                            </Text>
                                            <Text style={{
                                                display: 'block',
                                                textAlign: 'center',
                                                fontSize: '12px',
                                                color: '#666'
                                            }}>
                                                Alternatively, you can manually enter the activation code above
                                            </Text>
                                        </>
                                    )}
                                </div>
                            )}
                        </Col>
                    </Row>

                <div className='esim-success-actions'>
                  <Button
                    type='primary'
                    size='large'
                    onClick={() => history.push('/apply-for-esim')}
                  >
                    Continue Shopping
                  </Button>

                </div>

              </div> :
              <div className={'card-body'}>
                <div className='esim-success-header'>
                  <CloseCircleOutlined className='esim-danger-icon' />
                  <Title level={2} className='esim-success-title'>
                    Payment Failed!
                  </Title>
                  <Text className='esim-success-subtitle'>
                    Your eSIM has not been generate.
                  </Text>
                </div>

                <div className='esim-success-actions'>
                  <Button
                    type='primary'
                    size='large'
                    onClick={() => history.push('/apply-for-esim')}>
                    Continue Shopping
                  </Button>

                </div>

              </div>
            }
          </Card> : null}
        </div> :
        <div>
          <Card className='esim-success-card'>
            <Text>Invalid access. Please try again.</Text>
            <br />
            <Button onClick={() => history.push('/')}>Go Home</Button>
          </Card>
        </div>
      }

    </div>
  )
}

export default EsimSuccess
